﻿import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ng2SmartTableModule, LocalDataSource, ViewCell } from 'ng2-smart-table';

@Component({
    
    template: `
            <div class="table-responsive rowx">
                <table class="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                           
                            <th>Mã HĐ</th>
                            <th>Ngày HĐ</th>
                            <th>Khách hàng</th>
                            <th>Tổng tiền</th>
                            <th>Tiền tính hóa hồng</th>
                          
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor='let row of rowData.Details; let i = index'>                           
                            <td>{{row.SoHD}}</td>
                            <td>{{row.NgayHD| date: 'dd-MM-yyyy'}}</td>
                            <td>{{row.KhachHang}}</td>
                            <td>{{row.TongTien | number}}</td>
                            <td>{{row.TienHoaHong | number}}</td>
                           
                        </tr>

                    </tbody>
                </table>
            </div>
  `,
})
export class RowHoaHongViewComponent implements ViewCell, OnInit {
    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() print: EventEmitter<any> = new EventEmitter();
    @Output() del: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        
    }

    onPrintClick() {
        this.print.emit(this.rowData);
    }
    onDeleteClick() {
        this.del.emit(this.rowData);
    }
}